const countCompletedModules = (modules) => {
  if (!Array.isArray(modules) || modules.length === 0) return 0;

  let completedModules = 0;
  for (const module of modules) {
    if (
      module &&
      Array.isArray(module.steps) &&
      module.steps.length > 0 &&
      Array.isArray(module.steps[0].courses) &&
      module.steps[0].courses.length > 0
    ) {
      const allCompleted = module.steps[0].courses.every((course) => course && !!course.completed);
      if (allCompleted) completedModules++;
    }
  }
  return completedModules;
};

/**
 * Calculates the percentage of completed courses of a module, rounded up to the nearest integer.
 * @param {Array} moduleCourseList - Array of module objects.
 * @returns {number} - Percentage of completed modules.
 */
const calculateModuleCompletion = (moduleCourseList) => {
  if (!moduleCourseList || moduleCourseList.length === 0) return 0;
  const completedCount = moduleCourseList.filter((course) => course.completed).length;
  return Math.round((completedCount / moduleCourseList.length) * 100);
};

export { calculateModuleCompletion };

/**
 * Calculates the percentage of completed modules, rounded up to the nearest integer.
 * @param {Array} modules - Array of module objects.
 * @returns {string} - Percentage of completed modules.
 */
export const calculateOverallCompletionPercentage = (modules) => {
  const completedModules = countCompletedModules(modules);
  return completedModules === 0 ? '0%' : `${Math.round((completedModules / modules.length) * 100)}%`;
};

/**
 * Returns the number of completed modules.
 * @param {Array} modules - Array of module objects.
 * @returns {number} - Number of completed modules.
 */
export function calculateNumberCompletedModules(modules) {
  return countCompletedModules(modules);
}

/**
 * Determines if a module is completed.
 * A module is considered completed if:
 *   - It has non-empty steps array,
 *   - The first step has a non-empty `courses` array,
 *   - Every course in the first step has a truthy `completed` property.
 *
 * @param {Object} module - The module objects to check.
 * @returns {boolean} `true` if the module is completed, otherwise `false`.
 */
export const isModuleCompleted = (module) => {
  if (!module || !Array.isArray(module.steps) || module.steps.length === 0) {
    return false;
  }
  if (!Array.isArray(module.steps[0].courses) || module.steps[0].courses.length === 0) {
    return false;
  }
  return module.steps[0].courses.every((course) => course && !!course.completed);
};

export const getModuleCompletionStatus = (mod) => {
  if (!mod || !Array.isArray(mod.steps) || mod.steps.length === 0) {
    return 'notstarted';
  }

  if (isModuleCompleted(mod)) {
    return 'completed';
  }

  const foundRegistered = mod.steps.some((step) => Array.isArray(step.courses) && step.courses.some((course) => course.registered));

  return foundRegistered ? 'started' : 'notstarted';
};
